import TableActionMenu from "../../../../../../components/table-action-menu/table-action-menu";
import { Link } from "react-router-dom";
import { formatNumber } from "../../../../../../utils/utils";

export const tableMenuOptions = (
  exportEstimate,
  exportTimeline,
  exportSimpleEstimate,
  exportSimpleTimeline,
  exportGantt,
  isGeneralUser,
  plannerType
) => {
  // Materials only needs the normal estimate
  if (plannerType === "Materials") {
    return [
      {
        title: "Detailed Estimate PDF",
        onClick: () => exportEstimate(),
        disabled: isGeneralUser,
      },
    ];
  }

  // Fixed-Fee-Project only gets the normal estimate
  if (plannerType === "Fixed Fee Project") {
    return [
      {
        title: "Estimate PDF",
        onClick: () => exportEstimate(),
        disabled: isGeneralUser,
      },
    ];
  }

  // Time  Materials: simple first, then full
  if (plannerType === "Time + Materials") {
    return [
      {
        title: "Simple Estimate PDF",
        onClick: () => exportSimpleEstimate(),
        disabled: isGeneralUser,
      },
      {
        title: "Detailed Estimate PDF",
        onClick: () => exportEstimate(),
        disabled: isGeneralUser,
      },
      {
        title: "Simple Timeline PDF",
        onClick: () => exportSimpleTimeline(),
        disabled: isGeneralUser,
      },
      {
        title: "Detailed Timeline PDF",
        onClick: () => exportTimeline(),
        disabled: isGeneralUser,
      },
      // {
      //   title: "View Gantt Chart PDF",
      //   onClick: () => exportGantt(),
      //   disabled: isGeneralUser,
      // },
    ];
  }

  // Everything else (e.g. Fixed Fee Deliverable)
  return [
    {
      title: "Estimate PDF",
      onClick: () => exportEstimate(),
      disabled: isGeneralUser,
    },
    {
      title: "Timeline PDF",
      onClick: () => exportTimeline(),
      disabled: isGeneralUser,
    },
    // {
    //   title: "View Gantt Chart PDF",
    //   onClick: () => exportGantt(),
    //   disabled: isGeneralUser,
    // },
  ];
};

export const linkedProjectPlansColumns = (
  projectData,
  exportEstimate,
  exportTimeline,
  exportSimpleEstimate,
  exportSimpleTimeline,
  exportGantt,
  isGeneralUser
) => {
  return [
    {
      name: "Plan Name",
      dataKey: "projectName",
      width: "30%",
      align: "left",
      render: (cellData, rowData) => {
        const projectUrl = `/projectsview/${projectData.id}/planner`;
        return (
          <Link
            to={projectUrl}
            reloadDocument
            style={{
              textDecoration: "underline",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            {cellData}
          </Link>
        );
      },
    },
    {
      name: "Created (mm/dd/yyyy)",
      dataKey: "dateCreated",
      width: "15%",
      align: "left",
    },

    {
      name: "Services",
      dataKey: "plannerServiceValue",
      width: "15%",
      align: "left",
      render: (cellData, rowData) => {
        return `$ ${formatNumber(cellData)}`;
      },
    },
    {
      name: "Materials",
      dataKey: "materials",
      width: "15%",
      align: "left",
      value: "0",
      render: (cellData, rowData) => {
        // Format the number to always show two decimal places
        return `$ ${cellData}`;
      },
    },
    {
      name: "Discounts",
      dataKey: "discounts",
      width: "15%",
      align: "left",
      render: (cellData, rowData) => {
        // Convert each to a number before performing arithmetic
        const discounts =
          Number(rowData.plannerServiceValue) +
          Number(rowData.materials) -
          Number(rowData.projectTotal);
        return `$ ${formatNumber(discounts)}`;
      },
    },

    {
      name: "Total",
      dataKey: "projectTotal",
      width: "15%",
      align: "left",
      render: (cellData, rowData) => {
        return `$ ${formatNumber(cellData)}`;
      },
    },
    {
      name: "Status",
      dataKey: "status",
      width: "10%",
      align: "left",
    },

    {
      name: "",
      dataKey: "",
      width: "1%",
      align: "left",

      render: (cellData, rowData) => {
        const options = tableMenuOptions(
          exportEstimate,
          exportTimeline,
          exportSimpleEstimate,
          exportSimpleTimeline,
          exportGantt,
          isGeneralUser,
          projectData.plannerType
        );
        return (
          <div>
            <TableActionMenu
              noBorder
              options={options}
              // bgVariant={"outlined"}
            />
          </div>
        );
      },
    },
  ];
};
